import type { CalendarSlotStatus } from "@/types/contentCalendar.type";

export interface CalendarMoveRecord {
  id: string;
  brandId: string;
  planId: string;
  year: number;
  month: number;
  slotId: string;
  title: string;
  fromDay: number;
  toDay: number;
  fromPosition: number;
  toPosition: number;
  fromStatus: CalendarSlotStatus;
  toStatus: CalendarSlotStatus;
  createdAt: string;
  undoneAt: string | null;
}

const HISTORY_PREFIX = "creative-os:calendar-moves";
const HISTORY_LIMIT = 20;

function historyKey(brandId: string) {
  return `${HISTORY_PREFIX}:${brandId}`;
}

/** This is intentionally session-scoped: enough to recover work during the
 *  planning session, without leaving calendar titles in long-lived browser storage. */
export function loadMoveHistory(brandId: string): CalendarMoveRecord[] {
  if (typeof window === "undefined") return [];
  try {
    const parsed = JSON.parse(window.sessionStorage.getItem(historyKey(brandId)) ?? "[]");
    return Array.isArray(parsed) ? (parsed as CalendarMoveRecord[]) : [];
  } catch {
    return [];
  }
}

export function saveMoveHistory(brandId: string, records: CalendarMoveRecord[]) {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(
      historyKey(brandId),
      JSON.stringify(records.slice(0, HISTORY_LIMIT)),
    );
  } catch {
    // Storage can be unavailable in private/restricted contexts. The in-memory
    // ledger and immediate Undo action still work for the current page.
  }
}
